module.exports = __webpack_public_path__ + "static/media/p2_14.b769e88b.png";